import { Switch } from '@billda/design-system';

interface PermissionToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  testIdPrefix?: string;
  testIdSuffix?: string;
}

export const PermissionToggle = ({
  label,
  checked,
  onChange,
  disabled = false,
  testIdPrefix = '',
  testIdSuffix = '',
}: PermissionToggleProps) => {
  return (
    <label className="flex items-center gap-2 type-body-md">
      <Switch
        checked={checked}
        onCheckedChange={checked => onChange(checked === true)}
        disabled={disabled}
        data-testid={`${testIdPrefix ? `${testIdPrefix}-` : ''}permission-toggle${testIdSuffix ? `-${testIdSuffix}` : ''}`}
      />
      {label}
    </label>
  );
};
